import type {
	GadgetData,
	BackgroundScriptData as ConnectBackgroundScriptData,
} from '@atlassian/jira-dashboard-common/src/types';
import type { DashboardBackgroundScript as ForgeDashboardBackgroundScript } from '@atlassian/jira-forge-ui-types';
import { getSameEnvAppIdFromExtensionId } from '@atlassian/jira-forge-ui-utils/src/utils/parse-extension-id';
import type { ConnectBackgroundScript, SupportedBackgroundScript } from '../types';

const transformConnectItem = ({
	iframe: { addonKey, moduleKey, options },
}: ConnectBackgroundScriptData): ConnectBackgroundScript => ({
	appKey: addonKey,
	moduleKey,
	options: typeof options === 'string' ? JSON.parse(options) : options,
});

export const getScriptsForTheInstalledGadgets = ({
	gadgets,
	connectBackgroundScripts,
	forgeBackgroundScripts,
}: {
	gadgets: GadgetData[];
	connectBackgroundScripts: ConnectBackgroundScriptData[];
	forgeBackgroundScripts: ForgeDashboardBackgroundScript[];
}): SupportedBackgroundScript[] => {
	const forgeApps = new Set<string>();
	const connectApps = new Set<string>();

	gadgets.forEach((item) => {
		if (item.forge?.key != null) {
			forgeApps.add(getSameEnvAppIdFromExtensionId(item.forge.key));
		} else if (item.connect?.addonKey != null) {
			connectApps.add(item.connect.addonKey);
		}
	});

	return [
		...forgeBackgroundScripts.map(
			(item): SupportedBackgroundScript => ({
				type: 'forge',
				item,
			}),
		),
		...connectBackgroundScripts
			.filter((item) => connectApps.has(item.iframe.addonKey))
			.map(
				(item): SupportedBackgroundScript => ({
					type: 'connect',
					item: transformConnectItem(item),
				}),
			),
	];
};
